<template>
  <v-container flex>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
        <v-flex xs12>
          <v-toolbar
            color="#eee"
            class="elevation-0 secondary--text" >
            <v-toolbar-title>{{clube_vantagens ? 'Clientes do clube' : 'Clientes'}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" lazy width="500" :fullscreen="$vuetify.breakpoint.xs" hide-overlay>
              <v-btn icon color='info' slot="activator">
                <v-icon>add</v-icon>
              </v-btn>
              <cad-cliente v-on:fechar="dialog=false" v-on:info="showInfo" v-on:error="showError"></cad-cliente>
            </v-dialog>
            <v-dialog v-model="dialogSearchUser" lazy width="500" :fullscreen="$vuetify.breakpoint.xs" hide-overlay>
              <v-btn icon color='info' slot="activator">
                <v-icon>search</v-icon>
              </v-btn>
              <info-cliente v-on:fechar="dialogSearchUser=false" v-on:info="showInfo" v-on:error="showError" @consultar="detalhesCliente"></info-cliente>
            </v-dialog>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" round small color="secondary" @click="clube_vantagens = !clube_vantagens">
                  <v-icon class="mr-1">
                    {{clube_vantagens ? 'account_circle' : 'star'}}
                  </v-icon>
                  {{clube_vantagens ? 'Mostrar clientes' :'Clube de vantagens'}}
                </v-btn>
              </template>
              <span>{{clube_vantagens ? 'Mostrar todos os clientes' :'Mostrar clientes do clube'}}</span>
            </v-tooltip>
            <v-btn round small v-if="!clube_vantagens" :color="color" @click="alterarCor()" dark>{{textBotton}}</v-btn>
            <v-btn round small v-if="!clube_vantagens" :color="filter.ativo ? 'green' : 'red'" @click="btnAtivo" dark>{{filter.ativo ? 'Ativos' : 'Bloqueados'}}</v-btn>
            <v-btn round small color="primary" style="color: white" @click="dialogEnviarEmail = true">
              <v-icon style="margin-right: 2px;">email</v-icon> Enviar email
            </v-btn>
            <v-dialog lazy width="500" v-if="!telaCartoes && !dialogInflu" v-model="dialogDetalhesCliente" :fullscreen="$vuetify.breakpoint.xs">
              <detalhes-cliente
                :clienteSelecionado="cpfClienteSelecionado"
                @abrirTelaCartoes="cartoesCliente"
                @abrirTelaInfluenciador="telaDetalhesInfluenciador"
                @telaInfluenciador="telaInfluenciador"
                @fechar="fecharDetalhesCliente"
                v-on:error="showError"
                @sucess="showInfo"
                @erro="showError"
              />
            </v-dialog>
            <v-dialog v-model="dialogEnviarEmail" lazy width="850" :fullscreen="$vuetify.breakpoint.xs">
              <dialog-enviar-email @fechar="dialogEnviarEmail=false" @sucess="showInfo" @erro="showError"/>
            </v-dialog>
          </v-toolbar>
        </v-flex>
        <v-flex xs12>
          <v-alert
            v-if="alert"
            :value="true"
            type="error"
            class="pa-1 mb-3"
          >
            Existem estornos a serem realizados
          </v-alert>
          <v-data-table
            :headers="headersUsuarios"
            :items="usuarios"
            :loading="loading"
            :pagination.sync="pagination"
            :total-items="totalItems"
            hide-actions
          >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.pessoa.nome }}</td>
              <td class="text-xs-left">{{ props.item.pessoa.sobrenome }}</td>
              <td class="text-xs-center" v-if="props.item.pessoa.cpf">{{ props.item.pessoa.cpf | cpf }}</td>
              <td class="text-xs-center" v-else>{{  'Não possui' }}</td>
              <td class="text-xs-center">{{ props.item.pessoa.id_pessoa }}</td>
              <td class="text-xs-left">{{ props.item.pessoa.email }}</td>
              <td class="text-xs-center">
                <v-btn flat icon v-if="props.item.ativo === true" color="green lighten-2">
                  <v-icon>check_circle</v-icon>
                    ATIVO
                </v-btn>

                <v-btn flat icon v-else color="error">
                  <v-icon>cancel</v-icon>
                    INATIVO
                </v-btn>
              </td>
              <td class="text-xs-right">
                  <v-btn icon flat color="red" v-if="props.item.ativo" @click="desativarCliente(props.item)">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-btn v-else flat icon color="green" @click="ativarCliente(props.item)">
                    <v-icon>check</v-icon>
                  </v-btn>
                  <v-tooltip bottom>
                    <v-btn flat icon @click="telaInfluenciador(props.item)" slot="activator">
                      <v-icon class="mr-1" :color="props.item.is_influencer ? 'success' : 'gray'">record_voice_over</v-icon>
                    </v-btn>
                    <span>Influenciador</span>
                  </v-tooltip>
                  <v-btn flat icon :color="checarCatoes(props.item) === true ? 'error' : 'info'" @click="cartoesCliente(props.item)">
                  <v-icon class="mr-1">credit_card</v-icon>
                  </v-btn>
                  <v-btn title="Detalhes do cliente" flat icon color="primary" @click="detalhesCliente(props.item)">
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn title="Bloquear o cliente" flat icon color="primary" @click="bloquearCliente(props.item.pessoa)">
                    <v-icon>person_off</v-icon>
                  </v-btn>
              </td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-dialog v-if="telaCartoes" v-model="telaCartoes" width="50%" :fullscreen="$vuetify.breakpoint.xs">
        <cartoes-estorno :carregarClientes="carregarClientes(false)" :cliente="clienteSelecionado" @fechar="telaCartoes = false"/>
      </v-dialog>
      <v-dialog v-model="dialogBloquearCliente" width="400" :fullscreen="$vuetify.breakpoint.xs">
      <bloquear-cliente
        :cliente="clienteParaBloquear"
        @fechar="dialogBloquearCliente = false"
        @sucess="showInfo"
        @erro="showError"
      />
    </v-dialog>
      <v-dialog v-if="dialogInflu" v-model="dialogInflu" width="600" :fullscreen="$vuetify.breakpoint.xs">
        <cad-influenciador @carregarClientes="carregarClientes(false)" :cliente="clienteSelecionado" @fechar="dialogInflu = false"/>
      </v-dialog>
      <v-snackbar
        v-model="snackbar.active"
        :color="snackbar.color"
        :multi-line="snackbar.multiLine"
        :timeout="snackbar.timeout"
        :vertical="snackbar.vertical"
      >
        {{ snackbar.text }}
        <v-btn
          flat
          @click="snackbar.active = false"
        >
          Fechar
        </v-btn>
      </v-snackbar>
  </v-container>
</template>

<script>

import CadCliente from '@/components/cadastros/CadCliente'
import CadInfluenciador from '@/components/cadastros/CadInfluenciador'
import InfoCliente from '@/components/dialogs/DialogInfoCliente'
import DetalhesCliente from '@/components/dialogs/DetalhesCliente'
import SmartLockMessage from '@/components/SmartLockMessage'
import DialogEnviarEmail from '@/components/dialogs/DialogEnviarEmail'
import CartoesEstorno from '@/components/dialogs/CartoesEstorno'
import bloquearCliente from '@/components/dialogs/bloquearCliente'

export default {
  components: {
    CadCliente,
    InfoCliente,
    DetalhesCliente,
    SmartLockMessage,
    DialogEnviarEmail,
    CartoesEstorno,
    CadInfluenciador,
    bloquearCliente
  },
  data () {
    return {
      dialogEnviarEmail: false,
      colorSeletor: 1,
      color: 'green',
      textBotton: 'Liberados',
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      dialogBloquearCliente: false,
      clienteParaBloquear: null,
      dialogInflu: false,
      clube_vantagens: false,
      alert: false,
      dialogDetalhesCliente: false,
      clienteSelecionado: null,
      cpfClienteSelecionado: null,
      dialogSearchUser: false,
      dialog: false,
      telaCartoes: false,
      primeiroCarregamento: false,
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      filter: {
        ativo: true,
        verificado: true,
        clube: false
      },
      headersUsuarios: [
        { text: 'Nome',
          align: 'left',
          sortable: false,
          value: 'nome'
        },
        { text: 'Sobrenome',
          sortable: false,
          value: 'sobrenome'
        },
        { text: 'CPF',
          sortable: false,
          value: 'cpf',
          align: 'center'
        },
        { text: 'Número de identificação',
          sortable: false,
          value: 'id_pessoa',
          align: 'center'
        },
        { text: 'Email',
          sortable: false,
          value: 'email',
          align: 'left'
        },

        { text: 'Status',
          sortable: false,
          value: 'ativo',
          align: 'center'
        },
        {
          sortable: false,
          value: 'acao',
          align: 'right'
        }
      ]
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    totalItems () {
      return this.$store.getters.totalItemsUsuarios
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    usuarios () {
      return this.$store.getters.usuarios
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    paginationState () {
      return this.$store.getters.paginationUsuarios
    }
  },
  watch: {
    pagination: {
      handler (val) {
        if (this.primeiroCarregamento) this.$store.dispatch('paginateClientes', val)
      },
      deep: true
    },
    paginationState: {
      handler (val) {
        if (this.primeiroCarregamento) this.carregarClientes(false)
      },
      deep: true
    },
    clube_vantagens (val) {
      this.filter.clube = val
    }
  },
  filters: {
    cpf: function (value) {
      if (!value) return ''
      value = value.toString()
      value = value.slice(0, 3) + '.' + value.slice(3, 6) + '.' + value.slice(6, 9) + '-' + value.slice(9, 11)
      return value
    }
  },
  methods: {
    carregarClientes () {
      this.$store.dispatch('carregarUsuarios', this.filter).then(() => {
        this.primeiroCarregamento = true
      })
    },
    bloquearCliente (cliente) {
      console.log('Objeto cliente:', cliente)
      this.clienteParaBloquear = cliente
      this.dialogBloquearCliente = true
      console.log('dialogBloquearCliente:', this.dialogBloquearCliente)
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
    desativarCliente (user) {
      this.$store.dispatch('desativarCliente', user)
    },
    ativarCliente (user) {
      this.$store.dispatch('ativarCliente', user)
    },
    fecharDetalhesCliente () {
      this.clienteSelecionado = null
      this.dialogDetalhesCliente = false
    },
    detalhesCliente (obj) {
      this.cpfClienteSelecionado = obj.pessoa ? obj.pessoa.cpf : obj
      this.clienteSelecionado = obj.pessoa ? obj : null
      this.dialogDetalhesCliente = true
    },
    telaInfluenciador (obj) {
      // this.dialogDetalhesCliente = false
      this.clienteSelecionado = obj
      this.dialogInflu = true
    },
    telaDetalhesInfluenciador () {
      this.dialogDetalhesCliente = false
      this.dialogInflu = true
    },
    cartoesCliente (cliente) {
      this.dialogDetalhesCliente = false
      this.clienteSelecionado = cliente
      this.telaCartoes = true
    },
    alterarCor () {
      this.colorSeletor++
      switch (this.colorSeletor) {
        case 1:
          this.color = 'green'
          this.textBotton = 'Liberados'
          this.filter.verificado = true
          break
        case 2:
          this.color = 'red'
          this.textBotton = 'Recusados'
          this.filter.verificado = false
          break
        case 3:
          this.color = '#A9A9A9'
          this.textBotton = 'Pendentes'
          this.filter.verificado = null
          this.colorSeletor = 0
      }
      this.pagination.page = 1
    },
    checarCatoes (cliente) {
      let retorno = false
      cliente.cartao_cliente.forEach(cartao => {
        if (cartao.verificado === 3 && cartao.cancelado === false) {
          retorno = true
          return true
        }
      })
      return retorno
    },
    btnAtivo () {
      if (this.filter.ativo) {
        this.filter.ativo = false
      } else {
        this.filter.ativo = true
      }
      this.pagination.page = 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
